export default {
  // [通用数据] - 开通城市查询
  cities: '/courier/api/v2/cities',
  // 城市状态
  cityStatus: '/v3/recruit/cityStatus',
  // 确认城市
  submitCity: '/v3/h5/recruit/select/city',
  // 获取转城提示
  popupOfCity: '/v3/recruit/changeCity/popupOfCity' // 新接口
}
